import { z } from 'zod';

export const tagNameSchema = z
  .string()
  .includes(':', { message: 'Tag must include a colon (:)' })
  .refine((tag): tag is `${string}:${string}` => {
    const [, , ...rest] = tag.split(':');
    return !rest.length;
  }, 'Tag must include only one colon (:)')

  .refine((tag) => {
    const [key, value] = tag.split(':');
    return Boolean(key && value);
  }, 'Tag must include a key and value')

  .refine((tag) => {
    const [key] = tag.split(':');
    return key?.trim() === key;
  }, 'Tag key cannot include leading or trailing whitespace')

  .refine((tag) => {
    const [, value] = tag.split(':');
    return value?.trim() === value;
  }, 'Tag value cannot include leading or trailing whitespace')

  .refine((tag) => {
    const [key] = tag.split(':');
    return (key?.length ?? 0) <= 20;
  }, 'Tag keys cannot be longer than 20 characters')

  .refine((tag) => {
    const [, value] = tag.split(':');
    return (value?.length ?? 0) <= 50;
  }, 'Tag values cannot be longer than 50 characters');

export type TagName = z.infer<typeof tagNameSchema>;

/**
 * Checks only the key:value shape the {@link TagName} type requires. Unlike {@link tagNameSchema},
 * this accepts names that violate the new-input rules (length, whitespace) — tags created outside
 * this client may have such names but must still be addressable.
 */
export function isTagName(value: string): value is TagName {
  return value.includes(':');
}
